let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c1fpJ")).then(() => parcelRequire('e4Fch'));